/**
 * Was ein automatischer Besucher ohne Konto erfahren darf.
 *
 * Hier stand einmal das ganze Handbuch: wie die Anmeldung funktioniert,
 * woran die Sitzung gebunden ist, was eine Stufenmarke ist, welche
 * Geltungsbereiche es gibt, mit welchen Aufrufen man Seiten veröffentlicht
 * und Dateien ablegt. Öffentlich lesbar, ohne Konto — also eine Anleitung
 * zum Haus für jeden, der davorsteht.
 *
 * Geblieben ist, was ohnehin offen ist: die Adressen, die ohne Anmeldung
 * antworten. Alles andere steht unter `/api/help/agent` und kommt nur gegen
 * eine Marke oder eine Anmeldung heraus. Wer eine hat, darf alles nachlesen;
 * wer keine hat, erfährt nicht einmal, wonach er fragen könnte.
 *
 * Bewusst schlichtes HTML, keine Oberfläche drumherum: die Seite soll
 * gelesen werden, nicht gefallen.
 */
export function AiInfo() {
  return (
    <main className="ai-info">
      <h1>For automated clients</h1>
      <p>
        This is the public front of a private home server. Everything sits
        behind <code>/api</code>. Without an account or an API token, the
        endpoints below are all there is.
      </p>

      <h2>Reachable without signing in</h2>
      <ul>
        <li><code>GET /api/health</code> — whether the server is up.</li>
        <li><code>GET /api/container/list</code> — the files shared publicly.</li>
        <li><code>GET /api/public/files/modules</code> — storage modules marked public.</li>
        <li><code>GET /api/public/sites</code> — pages listed publicly.</li>
        <li><code>GET /api/public/sites/:slug</code> — one of them with its files.</li>
        <li><code>GET /api/public/f/:token</code> — a single shared file.</li>
        <li><code>GET /api/public/d/:token</code> — a shared folder and what is in it.</li>
        <li>
          <code>POST /api/public/reports</code> — report a problem you ran
          into here. Body: <code>{"{ title, text, kind: \"bug\" | \"idea\", source }"}</code>.
          Ten per hour and sender; the source is stored as{" "}
          <code>extern:&lt;source&gt;</code>, unverified and marked as such.
        </li>
      </ul>
      <p>
        Answers are JSON. Errors are{" "}
        <code>{"{ error, code, message }"}</code>.
      </p>

      <h2>Everything else</h2>
      <p>
        Needs an account or an API token. With either,{" "}
        <code>GET /api/help/agent</code> returns the full guide — signing in,
        tokens and their scopes, publishing a page, uploading a build, filing
        a report — and <code>GET /api/help/content</code> returns the complete
        in-app help as JSON.
      </p>
      <p>
        Tokens are issued by the owner under Settings → Tokens. There is no
        self-service: if you need one, ask the person who runs this server.
      </p>
    </main>
  );
}
